import { DateUtils, INITIAL_PERIOD } from '@core';
import { useState } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';

type PeriodListItem = { hash: number; value: string; label: string };
const currentDate = DateUtils.now();
const currentYear = currentDate.getFullYear();
const currentQuarter = Math.ceil((currentDate.getMonth() + 1) / 3);

const generatePeriodList = (): PeriodListItem[] => {
  const periodList = [];
  for (let year = INITIAL_PERIOD.year; year <= currentYear; year++) {
    let quarter = year === INITIAL_PERIOD.year ? INITIAL_PERIOD.quarter : 1;
    let lastQuarter = year === currentYear ? currentQuarter : 4;
    for (; quarter <= lastQuarter; quarter++) {
      const value = year + '-' + quarter;
      periodList.push({ hash: +(year + '' + quarter), value, label: value });
    }
  }
  return periodList;
};

const fromPeriodList = [{ hash: 0, value: 'oldest', label: 'Always Oldest' }, ...generatePeriodList()];
const toPeriodList = [{ hash: 100000, value: 'newest', label: 'Always Newest' }, ...generatePeriodList().reverse()];

export function PeriodSelector(props: {
  fromPeriod?: string;
  toPeriod?: string;
  onChange?: (value: { fromPeriod?: string; toPeriod?: string }) => void;
}) {
  const [fromPeriodValue, setFromPeriodValue] = useState(props.fromPeriod || 'oldest');
  const [toPeriodValue, setToPeriodValue] = useState(props.toPeriod || 'newest');

  const fromPeriod = fromPeriodList.find((item) => item.value === fromPeriodValue);
  const toPeriod = toPeriodList.find((item) => item.value === toPeriodValue);

  return (
    <div className="d-flex flex-row">
      <FloatingLabel controlId="fromPeriod" label="From" className="mb-3 flex-grow-1 me-1">
        <Form.Select
          name="fromPeriod"
          aria-label="Select a script type"
          value={fromPeriodValue}
          onChange={(event) => {
            setFromPeriodValue(event.target.value);
            props.onChange && props.onChange({ fromPeriod: event.target.value });
          }}
        >
          {fromPeriodList
            .filter((period) => period.hash < toPeriod.hash)
            .map((period) => (
              <option value={period.value} key={period.value}>
                {period.label}
              </option>
            ))}
        </Form.Select>
      </FloatingLabel>
      <FloatingLabel controlId="toPeriod" label="To" className="mb-3 flex-grow-1 ms-1">
        <Form.Select
          name="toPeriod"
          aria-label="Select a script type"
          value={toPeriodValue}
          onChange={(event) => {
            setToPeriodValue(event.target.value);
            props.onChange && props.onChange({ toPeriod: event.target.value });
          }}
        >
          {toPeriodList
            .filter((period) => period.hash > fromPeriod.hash)
            .map((period) => (
              <option value={period.value} key={period.value}>
                {period.label}
              </option>
            ))}
        </Form.Select>
      </FloatingLabel>
    </div>
  );
}
